const or = {
  // Navigation & General
  All: "Hunda/Hundumaa",
  SearchPublishedLawImplementations: "Search Published Law Implementations", // No Oromo translation
  Back: "Duuba Deebi'i",
  View: "Ilaali/Agarsiisi",
  Action: "Gochaa",
  Cancel: "Haquu",
  Save: "Kusuu",
  SaveChanges: "Save Changes", // No Oromo translation
  Submit: "Dhiyeessuu",
  Submitting: "Galii gochuu...",
  Refresh: "Haaromsuu",
  Note: "Hubadhu (Akeekkadhu)",
  Remark: "Yaadachiisa",
  Date: "Guyyaa",
  DraftSummary: "Cuunfaa Wixinee",
  NoLetterReferenceNumberYet: "Lakkoofsi Xalayaa duraa hin jiru.",
  CompletionLetterUploaded: "Xalayeen Xumuramaa Fe'ameera",
  Uploading: "Fe'aa jira...",
  StakeholderName: "Maqaa Qooda-Fudhattaa",
  AppliedDate: "Guyyaa Iyyannoon Itti Dhiyaate",
  AssignedTo: "Itti Ramadamuu",
  FeedbackSection: "Kutaa Duub Deebii",
  RespondBackSection: "Kutaa Deebiin Kennamu",
  CommentedDate: "Guyyaa Yaadachiisni Itti Kennamed",
  WriteBackResponseHere: "Deebii Asitti Barreessi",
  Status: "Sadarkaa/Haala irra jiru",
  Title: "Mata-Duree (Moggaasa)",
  Name: "Maqaa",
  Forward: "Erguu/Dabarsuu/Kennuu",
  WriteHere: "Asitti barreessi...",
  ConfirmForward: "Dabarsuun Mirkaneeffameera",
  ConfirmForwardMessage: "Gaaffii kana dabarsuutti amanteettaa? Gochi kun duubatti deebi'uu hin danda'u.",
  Researches: "Qorannoo",
  ConductLegalResearch: "Qorannoo Seeraa Gaggeessuu",
  LegislativeDrafting: "Seera Wixineessuu/Wixineessa Seeraa qopheessuu",
  LegalAdvisory: "Gorsa Seeraa",
  LawImplementation: "Hojiirra Oolmaa Seeraa",
  LegalAwarenessCreation: "Hubannoo Seeraa Uumuu",
  LegalTrainingProvision: "Kenniinsa Leenjii Seeraa",
  LegalTranslation: "Hiikkaa Seeraa",
  ConductLegislativeRequest: "Gaaffii Seera Baasuu Dhiyeessuu",
  RequestLegislativeLetterNumber: "Request Legislative Letter Number", // No Oromo translation
  RegisterDirective: "Qajeelfama Galmeessi/uu",
  SectorDirectives: "Qajeelfamoota Seektaraa",
  NewRequest: "Gaaffii Haaraa",
  CreateCommitteeRequest: "Gaaffii Koree Uumi",
  CreateInternalRequest: "Gaaffii Keessaa Dhiyeessu",
  InternalRequestTopics: "Mata dureewwan Gaaffii Keessoo",
  CreateNewRequest: "Gaaffii Haaraa Qopheessi",
  RequestTable: "Gabatee Gaaffii",
  RequestType: "Gosa Gaaffii",
  RequestDetail: "Ibsa Gaaffii",
  RequestBy: "Kan Gaafate",
  ApplicationNumber: "Lakkoofsa Iyyannoo",
  ForwardStatus: "Sadarkaa Erguu",
  ViewAction: "Gochaa Agarsiisi/Ilaali",
  InProgress: "Deemsa Foyya'iinsaa Irra jira",
  RequestForLegislativeDrafting: "Request for Legislative Drafting", // No Oromo translation
  Accepted: "Fudhatameera",
  NotYetAccepted: "Hanga Yoonaatti Hin fudhatamne",
  Rejected: "Kufaa Ta'eera (Haqameera)",
  UnderRevision: "Irradeebi'iin Iaalamaa jira",
  Approved: "Mirkanaa'eera/Ragga'eera/Eyyamameera",
  Recommended: "Ni gorfama/Ni deeggarama",
  Published: "Maxxanfame",
  Archived: "Kuusaa keessa jira",
  CurrentStatus: "Current Status", // No Oromo translation
  broadcasted: "Tamsa'eera",
  draft_approved: "Wixinee Mirkanaa'eera",
  draft_submitted: "Wixinee Dhiyaateera",
  final_approval: "Mirkaneessa Xumuraa",
  forwarded_to_coordinator: "Qindeessaaf Ergameera",
  forwarded_to_director: "Daayrektaraaf Ergameera",
  legal_draft_approved: "Wixinee Seeraa Mirkanaa'eera",
  published: "Maxxanfame",
  submitted: "Galii taasifameera",
  team_setup: "Garee Qopheessuu",
  additional_info_submitted: "Odeeffannoo Dabalataan ergameera",
  additional_info_response_submitted: "Deebii Odeeffannoo Dabalataa ergameera",
  coordinator_remark_submitted: "Yaadachiisa Qindeessaa ergameera",
  director_remark_submitted: "Yaadachiisa Daayrektaraa ergameera",
  Researcher: "Qorataa",
  Member: "Miseensa",
  Members: "Miseensota",
  Coordinator: "Qindeessaa",
  Prosecutor: "Abbaa Alangaa",
  TeamLeader: "Dursaa Garee",
  is_team_leader: "Dursaa Gareedha",
  IsTeamLeader: "is Team Leader", // No Oromo translation
  RegNumber: "Lakkoofsa galmee",
  ResearchTopic: "Mata Duree Qorannoo",
  Abstract: "Qabiyyee Bal'aa Qorannoo Gabaabbinaan Cuunfame",
  ResearchDraftSummary: "Cuunfaa Wixinee Qorannoo",
  NoSummaryAvailable: "Cuunfaan hin jiru",
  Summary: "Cuunfa (Guduunfaa)",
  EditSummary: "Cuunfaa Gulaali",
  EnterSummaryPlaceholder: "Cuunfaa galchi...",
  SummaryOfComments: "Cuunfaa Yaadachiisaa",
  SummaryOfWrittenComments: "Cuunfaa Yaada Galtee barreeffamaa",
  SummaryWritten: "Cuunfaa barreefame",
  summary_of_comments: "Cuunfaa Yaadachiisaa",
  summary_updated_success: "Cuunfaan milkaa'inaan haaromfame!",
  PreviousVersions: "Waraabbiiwwan Duraanii",
  previous_version_one: "waraabbii darbe",
  previous_version_other: "waraabbiiwwan darbe",
  ViewTeam: "Garee Agarsiisi",
  ResearchFinding: "Bu'aa Qorannoo",
  CheckingAccuracyOfSectorDirectives: "Checking Accuracy of Sector Directives", // No Oromo translation
  RequestForCheckingAccuracyOfSectorDirectives: "Request for Checking Accuracy of Sector Directives", // No Oromo translation
  SectorDirectiveAccuracyCheck: "Sector Directive Accuracy Check", // No Oromo translation
  RequestLetter: "Xalayaa Gaaffii",
  DirectiveFile: "Faayila Qajeelfamaa",
  AdditionalInfoDoc: "Sanada Odeeffannoo Dabalataa",
  AmendedFile: "Faayila Fooyya'e",
  AmendedLegislativeFile: "Faayila Wixinee Seeraa Fooyya'e",
  CompletionLetter: "Xalayaa Xumuramaa",
  CompletionLetterFile: "Faayila Xalayaa Xumuramaa",
  UploadCompletionLetter: "Xalayaa Xumuramaa Fe'i",
  FeedbackFile: "Faayila Duub-Deebi'ii",
  RespondBackFile: "Faayila Deebisii",
  ReplaceWrittenCommentsFile: "Faayila Yaada Galtee Bakka Buusi (filannoodhaan)",
  WrittenComments: "Yaada Galtee barreeffamaa",
  NoDocumentsUploadedYet: "Hanga yoonaatti sanadni hin fe'amne.",
  ProposalSubmitted: "Piropozaaliin Dhiyaateera",
  ProposalApprovedSuccess: "Piropozaaliin milkaa'inaan mirkanaa'eera!",
  SavedSuccessfully: "Milkaa'inaan kussameera!",
  ForwardedSuccess: "Milkaa'inaan ergameera!",
  ForwardedSuccessfully: "Milkaa'inaan ergameera!",
  AdditionalInfoSubmittedSuccess: "Odeeffannoon Dabalataan milkaa'inaan ergameera!",
  FeedbackSubmittedSuccess: "Duub-Deebiin milkaa'inaan ergameera!",
  LegislativeFeedbackSubmittedSuccess: "Legislative Feedback submitted successfully!", // No Oromo translation
  LegislativeDraftForwardedSuccess: "Legislative Draft Forwarded successfully!", // No Oromo translation
  RespondBackSubmitted: "Deebiin Kennuun ergameera",
  CannotForwardBeforeEditing: "Gulaaluun dura erguun hin danda'amu.",
  CannotRemoveOnlyTeamLeader: "Dursaa Garee Qofa hin maqsu. Maaloo dura dursaa garee haaraa ramadi yookiin miseensa biraa dabali.",
  PleaseAddTeamMemberBeforeForwarding: "Yoo xiqqaate miseensa tokko gareetti dabali.",
  SetupTeamMembers: "Miseensota Garee Qopheessi",
  SelectProsecutor: "Abbaa Alangaa fili",
  AddSelectedProsecutorToTeam: "Abbaa-Alangaa Filatame Gareetti dabali",
  NoTeamMembersAdded: "Miseensi garee hanga yoonaatti hin dabalame.",
  NoTeamMembersAddedYet: "Hanga yoonaatti miseensi garee hin dabalame.",
  TeamList: "Tarree Garee",
  ProsecutorAlreadyAdded: "Abbaan Alangaan kun gareetti dabalameera.",
  ApprovalAndForward: "Approval and Forward", // No Oromo translation
  ForwardToCoordinator: "Qindeessaaf Dabarsi",
  ForwardToDirector: "Daayrektaraaf Dabarsi",
  ForwardToProsecutors: "Abbootii-Alangaaf Dabarsi",
  SetupTeamAndForwardToProsecutor: "Garee Qopheessi fi Abbaa Alangaa ergi",
  FinalApproveDraftLaw: "Final Approve Draft Law", // No Oromo translation
  BroadcastToPublicWebsite: "Toora Interneetii Ummataatti Tamsaasi",
  Feedback: "Duub-Deebii",
  PublicFeedback: "Duub-Deebii Ummataa",
  RespondBack: "Deebi'ii Kenni",
  RespondBackFeedback: "Duub Deebii Deebisi",
  AdditionalInformationRequest: "Gaaffii Odeeffannoo Dabalataa",
  AdditionalInformationResponse: "Deebii Odeeffannoo Dabalataa",
  RequestForAdditionalInfo: "Odeeffannoo Dabalataa Gaafachuu",
  DirectorRemark: "Yaadachiisa Daayrektaraa",
  DetailHere: "Ibsi asitti...",
  NoFeedbackYet: "Hanga yoonaatti duub-deebiin hin jiru.",
  SendFeedback: "Duub-Deebii Ergi",
  RegistrarActions: "Registrar Actions", // No Oromo translation
  LetterReferenceNumber: "Lakkoofsa Xalayaa",
  LetterReferenceNumberPlaceholder: "Fak. 12345",
  Selected: "Filatame",
  additional_info_summary: "Cuunfaa odeeffannoo dabalataa",
  additional_info_response_note: "Additional Info Response Note", // No Oromo translation
  requested_document_detail: "Ibsa Sanada Gaafatame",
  Address: "Teessoo",
  search_title: "Qorannoo Seeraa Barbaadi",
  search_label: "Lakkoofsa waraabbii adda baasi",
  search_placeholder: "Lakkoofsa waraabbii galchi...",
  searching: "Barbaadaa jira...",
  search_button: "Barbaadi",
  results_count: "{{count}} bu'aan \"{{term}}\" jedhameef argame",
  loading_message: "Qorannoo fe'aa jira...",
  no_results_found: "Bu'aan \"{{term}}\" jedhameef hin argamne",
  no_data_yet: "Hanga yoonaatti qorannoon hin jiru.",
  search_translation_papers_title: "Waraqaa Hiikaa Barbaadi",
  loading_translation_data: "Hiikaa fe'aa jira...",
  no_translation_papers_yet: "Hanga yoonaatti waraqaan hiikaa seeraa hin ergamne",
  select_translation_paper_details: "Ibsa argachuuf waraqaa hiikaa fili",
  search_failed: "Barbaachuun kufeera",
  failed_to_fetch_legal_translation: "Failed to fetch Legal Translation request.", // No Oromo translation
  search_public_register_directives: "Qajeelfamoota Galmee Ummataa Barbaadi",
  search_by_ref_num_or_org: "Lakkoofsa ykn dhaabbata adda baasi.",
  loading_public_directives: "Qajeelfamoota fe'aa jira...",
  no_public_register_directives_yet: "Hanga yoonaatti qajeelfamni galmee ummataa hin jiru",
  select_directive_to_view_details: "Ibsa argachuuf qajeelfama fili",
  SelectResearchPaperToViewDetails: "Ibsa argachuuf qorannoo fili",
  NoteText: "Sanadonni barbaachisan hundi fe'amanii fi bakkeewni sirriin guutamaniinsaa mirkaneeffadhu.",
  NoteSubtext: "Xalayaan gaaffii fi faayiliin qajeelfamaa haala qaaccessaan, lakkoofsi waraabbii fi ibsi ibsameen kennamuu qaba.",
  DocumentRequirementsTitle: "Yaa'ina Sanadaa Sirreeffama Qajeelfamoota Damee Sakatta'uuf",
  DocumentRequirementsDescription: "Sanadonni fi odeeffannoon barbaachisan hundi akka kennaman mirkaneeffadhu.",
  FailedToFetchLegalResearchRequest: "Failed to fetch legal research request.", // No Oromo translation
  FailedToFetchStakeholder: "Qooda-fudhattaa argachuun hin danda'amne.",
  FailedToFetchEmployees: "Hojjattoota argachuun hin danda'amne.",
  FailedToFetchSectorDirectives: "Qajeelfamoota damee argachuun hin danda'amne.",
  FailedToRequestAdditionalInformation: "Odeeffannoo dabalataa gaafachuun hin danda'amne.",
  FailedToUpdateApproval: "Failed to update approval.", // No Oromo translation
  FailedToUpdateDraft: "Failed to update draft.", // No Oromo translation
  FailedToUpdateLegalResearchRequest: "Failed to update legal research request.", // No Oromo translation
  FailedToUpdateSectorDirectiveRequest: "Failed to update Sector Directive request.", // No Oromo translation
  FailedToUpdateSummary: "Failed to update summary.", // No Oromo translation
  FailedToUpdateRequest: "Failed to update request.", // No Oromo translation
  FailedToUpdateLegislativeDraftRequest: "Failed to update Legislative Draft request.", // No Oromo translation
  FailedToUploadFile: "Faayila fe'uun hin danda'amne.",
  ErrorFetchingDirectiveRequests: "Dogoggora gaaffii qajeelfamaa argachuuf:",
  FailedToFetchDirectiveRequests: "Failed to fetch Directive requests.", // No Oromo translation
  SearchFailed: "Barbaachi kufeera",
  ExplanatoryNote: "Ibsa Barbaachisummaa",
  Stakeholder: "Qooda-Fudhattaa",
  RemarkForDirector: "Yaadachiisa Daayrektaraaf",
  RemarkForCoordinator: "Yaadachiisa Qindeessaaf",
  RemarkForProsecutor: "Yaadachiisa Abbaa-Alangaaf",
  Broadcasted: "Tamsa'eera",
  Approve: "Raggaasi/Mirkaneessi",
  letter_ref_number_required: "Maaloo lakkoofsa xalayaa galchi",
  explanatory_notes_required: "Maaloo ibsa barbaachisummaa galchi",
  letter_required: "Xalayaan gaaffii ni barbaachisa",
  file_required: "Faayiliin qajeelfamaa ni barbaachisa",
  fill_all_fields: "Maaloo bakkeewwan barbaachisan hundi guuti",
  request_success: "Gaaffiin milkaa'inaan ergameera",
  request_failed: "Gaaffii erguun kufeera",
  send_request: "Gaaffii Ergi",
  note_text: "Sanadonni barbaachisan hundi fe'amanii fi bakkeewni sirriin guutamanii akka ta'an mirkaneeffadhu.",
  note_subtext: "Xalayaan gaaffii fi faayiliin qajeelfamaa, lakkoofsi waraabbii fi ibsi ibsameen kennamuu qaba.",
  requirements_title: "Yaa'ina Sanadaa Sirreeffama Qajeelfamoota Damee Sakatta'uuf",
  requirements_desc: "Sanadonni fi odeeffannoon barbaachisan hundi akka kennaman mirkaneeffadhu.",
  letter_ref_number_label: "Lakkoofsa Xalayaa",
  letter_ref_number_placeholder: "Fak. 12345",
  explanatory_notes_label: "Explanatory Note", // No Oromo translation
  request_title: "Request for Checking Accuracy of Sector Directives", // No Oromo translation
  submit_request_desc_alt: "Submit a new request for sector directive accuracy verification", // No Oromo translation
  AdditionalInfoSummary: "Cuunfaa odeeffannoo dabalataa",
  AddAdditionalInfo: "Odeeffannoo dabalataa dabali",
  NoMessagesYet: "Hanga yoonaatti ergaan hin jiru",
  NoRespondBackFeedbackYet: "Hanga yoonaatti Deebiin duub-deebii hin jiru",
  WrittenCommentsFile: "Written Comments File", // No Oromo translation
  RequestedDocumentDetail: "Ibsa Sanada Gaafatame",
  LegalResearchProposalApproved: "Legal research proposal Approved!", // No Oromo translation
  FailedToUpdateLegalResearchProposalApproval: "Failed to update legal research proposal Approval.", // No Oromo translation
  RequestForAdditionalInfoTitle: "Gaaffii Odeeffannoo Dabalataa",
  ResearchDataPublishedPublic: "Research Data Published Public", // No Oromo translation
  NoImplementationDirectionAvailable: "No implementation direction available", // No Oromo translation
  TeamLeaderAvatarAlt: "Fakkii Dursaa Garee",
  Unknown: "Hin beekamne",
  PlusMoreMembers: "+ {{count}} dabalataa",
  MemberCount: "{{count}} Miseensa",
  MemberCount_plural: "{{count}} Miseensota",
  PageneshTwoItems: "Pagenesh: 2 Gosa",
  PageneshCount: "Pagenesh: {{count}}",
  PleaseProvideSummaryOrFile: "Maaloo cuunfaa ykn faayila kenni",
  ResearchUpdatedSuccessfully: "Qorannoon milkaa'inaan haaromfame",
  FailedToUpdateResearch: "Qorannoo haaromsuun kufeera",
  ReuploadResearchDraftFile: "Faayila Wixinee Qorannoo Irra Deebi'ii Fe'i",
  ResearchDraftFile: "Faayila Wixinee Qorannoo",
  LatestResearchDraft: "Wixinee Qorannoo Haaraa",
  VersionNumber: "Gossha {{version}} - {{date}}",
  ResearchDataPublished: "Research Data Published", // No Oromo translation
  PublishDraftLegislationForPublic: "Publish Draft Legislation For Public", // No Oromo translation
  LastUpdated: "Yeroo dhumaaf haaromfame",
  NoDraftSummaryAvailable: "Cuunfaan wixinee hin jiru",
  PreviousVersion: "Waraabbii Duraa",
  PreviousVersion_plural: "Waraabbiiwwan Duraanii",
  PublishedLegalDraftsPublic: "Published Legal Drafts : Public Reg Number", // No Oromo translation
  NoDraftInstructionSummaryAvailable: "No draft instruction summary available", // No Oromo translation
  LegislativeDrafter: "Wixineessaa Seeraa",
  Verified: "Mirkanaa'eera",
  search_drafting_papers_title: "Waraqaa Wixineessa Seeraa Barbaadi",
  search_drafting_papers_label: "Lakkoofsa waraabbii, dhaabbata, ykn cuunfaan adda baasi...",
  search_drafting_papers_placeholder: "Fak. 12345, maqaa dhaabbataa, cuunfaa wixinee...",
  loading_drafting_data: "Wixineessa seeraa fe'aa jira...",
  no_legal_drafting_papers_yet: "Hanga yoonaatti waraqaan wixineessa seeraa hin ergamne",
  select_drafting_paper_to_view: "Ibsa argachuuf waraqaa wixineessa seeraa fili",
  BroadcastStatusUpdated: "Haalli tamsaasii haaromfame",
  FailedToUpdateBroadcastStatus: "Haala tamsaasii haaromsuun hin danda'amne",
  FailedToFetchLegalDraftingPapers: "Failed to fetch legal drafting papers.", // No Oromo translation
  broadcast_draft_legislation_title: "Broadcast Draft Legislation to Public", // No Oromo translation
  broadcast_draft_legislation_description: "Share your completed legal draft with the public to increase transparency and accessibility.", // No Oromo translation
  broadcast_draft_legislation_additional_info: "Once broadcasted, the draft will be publicly accessible.", // No Oromo translation
  OfficialLegalTranslationPublished: "Official Legal Translation Published", // No Oromo translation
  NoTranslationSummaryAvailable: "No translation summary available", // No Oromo translation
  LegalTranslator: "Hiikaa Seeraa (Ogeessa Hiika Seeraa)",
  TranslatedFile: "Faayila Hiikame",
  PleaseSelectAtLeastOneFile: "Please select at least one file to upload.", // No Oromo translation
  PleaseEnterReferenceNumberForCompletion: "Please enter a reference number for the completion letter.", // No Oromo translation
  FilesUploadedSuccessfully: "Files uploaded successfully!", // No Oromo translation
  FailedToUploadFiles: "Failed to upload files.", // No Oromo translation
  UploadFiles: "Upload Files", // No Oromo translation
  ReferenceNumberForCompletionLetter: "Reference Number (for completion letter)", // No Oromo translation
  EnterReferenceNumber: "Enter reference number", // No Oromo translation
  DraftTranslationFileOptional: "Draft Translation File (optional)", // No Oromo translation
  SelectDraftFile: "Select Draft File", // No Oromo translation
  TranslationCompletionLetterOptional: "Translation Completion Letter (optional)", // No Oromo translation
  SelectCompletionLetter: "Select Completion Letter", // No Oromo translation
  Hide: "Dhoksi",
  Show: "Agarsiisi",
  LegallyTranslatedAndPublished: "Legally Translated and Published:", // No Oromo translation
  FailedToFetchLegalTranslation: "Failed to fetch legal translation request.", // No Oromo translation
  Saving: "Kusaa jira...",
  previous_version: "waraabbii darbe",
  previous_version_plural: "waraabbiiwwan darbe",
  StakeholderType: "Gosa Qooda-Fudhattaa",
  Email: "Imeelii",
  SummaryWrittenComments: "Summary Written Comments", // No Oromo translation
  LegalResearchForwardedSuccess: "Legal research forwarded successfully!", // No Oromo translation
  UpdatedAdditionalInformation: "Updated Additional Information", // No Oromo translation
  DraftLawUploaded: "Draft Law Uploaded", // No Oromo translation
  FailedToUploadDraftLaw: "Failed to upload Draft Law.", // No Oromo translation
  DraftLaw: "Wixinee Seeraa",
  DraftLawFile: "Faayila Wixinee Seeraa",
  AdditionalInformationRequested: "Additional Information Requested", // No Oromo translation
  MessengerDetail: "Ibsa Ergamaa (Miseenjarii)",
  FileTooLargeMessage: "File is too large. Maximum size allowed per file is {{size}}MB.", // No Oromo translation
  TotalFileTooLargeMessage: "Total file size is too large. Maximum total size allowed is {{size}}MB.", // No Oromo translation
  LegislativeDraftSentSuccess: "Legislative draft sent successfully!", // No Oromo translation
  FailedToSendLegislativeDraft: "Failed to send Legislative draft request.", // No Oromo translation
  LegislativeDraftingSubtitle: "Legislative Drafting Subtitle", // No Oromo translation
  RequestLetterReferenceNumber: "Lakkoofsa Xalayaa Gaaffii",
  DraftInstructionSummary: "Draft Instruction Summary", // No Oromo translation
  RequestLetterRequired: "Xalayaa Gaaffii*",
  DraftInstructionRequired: "Draft Instruction*", // No Oromo translation
  SelectOrganization: "Dhaabbata Fili",
  DocumentRequirements: "Yaa'ina Sanadaa",
  LegalResearchRespondedBackSuccess: "Legal research responded back successfully!", // No Oromo translation
  DraftLawDetail: "Ibsa Wixinee Seeraa",
  LatestLawDraft: "Latest Law Draft", // No Oromo translation
  PreviousDraft: "Wixinee Duraa",
  DraftInstruction: "Draft Instruction", // No Oromo translation
  SubmitReferenceNumber: "Submit Reference Number", // No Oromo translation
  LegalDraftingCompletionLetter: "Xalayaa Xumuramaa Wixinee Seeraa",
  AmendedDraftFile: "Faayila Wixinee Fooyya'e",
  SubmitFiles: "Faayiloota Dhiyeessi",
  WaitingAdditionalInfo: "Odeeffannoo dabalataa eegaa jira",
  DraftLawNotEssential: "Draft Law Not Essential", // No Oromo translation
  File: "Faayila",
  AdditionalInfoFile: "Faayila Odeeffannoo Dabalataa",
  Forwarding: "Ergaa jira...",
  ReDraftLaw: "Seera Irradeebi'iin Wixineessi",
  NonEssential: "Barbaachisaa Miti",
  BroadcastLegislativeDraftToPublic: "Wixinee Seeraa Uummataaf Tamsaasi",
  BroadcastLegislativeDraftDescription: "Wixinee seeraa kee kan xumurame iftoominaa fi dhaqqabamummaa dabaluuf ummata wajjiin qooddadhu.",
  BroadcastLegislativeDraftAdditionalInfo: "Wixinichi akkuma tamsa'een ifaa fi bal'inaan dhaqqabamaa waan ta'uuf namni kamiyyuu ilaaluu danda'a.",
  EnterDraftSummary: "Cuunfaa wixinee...",
  ReuploadDraftFileOptional: "Faayila Wixinee Irra Deebi'ii Fe'i (filannoodhaan)",
  Version: "Gossha",
  LatestAmendedLawFile: "Faayila Seeraa Fooyya'e Haaraa",
  PreviousAmendedLawFiles: "Faayiloota Seeraa Fooyya'e Duraanii",
  LatestPublicFeedbackFile: "Faayila Duub-Deebii Ummataa Haaraa",
  PreviousPublicFeedbackFiles: "Faayiloota Duub-Deebii Ummataa Duraanii",
  SubmitPublicFeedback: "Duub-Deebii Ummataa Dhiyeessi",
  UploadAmendedLegislativeFile: "Faayila Wixinee Seeraa Fooyya'e Fe'i",
  AuditSummary: "Cuunfaa Odiitii",
  AuditDocument: "Sanada Odiitii",
  UploadAuditLegislativeDraft: "Wixinee Seeraa Odiitii Fe'i",
  AllowPublicFeedback: "Duub-Deebii Ummataa Hayyami",
  RegisterNumber: "Lakkoofsa Galmeessi",
  LatestDraftLawFile: "Faayila Wixinee Seeraa Haaraa",
  NoComment: "Yaada Hin jiru",
  ConfirmBroadcast: "Tamsaasa Mirkaneessi",
  ConfirmBroadcastMessage: "Wixinee seeraa kana ummataaf tamsaasuu barbaadduu mirkaneeffatteettaa? Gochi kun duubatti deebi'uu hin danda'u.",
  Broadcast: "Tamsaasi",
  PleaseProvideRemark: "Maaloo deebisuu dura yaadachiisa kenni",
  SessionExpired: "Yeroon kee xumurame. Maaloo irra deebi'ii seeni.",
  PleaseWriteRemarkBeforeForwarding: "Maaloo erguu dura yaadachiisa barreessi.",
  ForwardedToCoordinatorSuccess: "Qindeessaaf milkaa'inaan ergameera!",
  FailedToForwardRequest: "Gaaffii erguun kufeera.",
  TeamSetupAndForwardedSuccess: "Gareen qopheeffamee fi Abbaa Alangaaf milkaa'inaan ergameera!",
  ailedToFetchLegalTranslation: "Failed to fetch legal translation request.", // No Oromo translation
  LegalTranslationRequest: "Gaaffii Hiika Seeraa",
  LegalTranslationSubtitle: "Legal Translation Subtitle", // No Oromo translation
  SupportingDocumentsForTranslationRequired: "Supporting Documents for Translation*", // No Oromo translation
  EnterReferenceNumberPlaceholder: "Lakkoofsa waraabbii galchi (fak. #12345)",
  SummaryOfTranslationRequest: "Cuunfaa Gaaffii Hiikaa",
  SummaryOfTranslationRequestPlaceholder: "Cuunfaa sanadootaa fi kaayyoo hiikaa kenni...",
  SubmitRequest: "Gaaffii Dhiyeessi",
  OfficialRequestLetter: "Xalayaa Gaaffii Iddoo Haalaa",
  RequestLetterReferenceNumberRequired: "Request Letter Reference Number is required", // No Oromo translation
  SummaryOfTranslationRequestRequired: "Cuunfaan Gaaffii Hiikaa ni barbaachisa",
  AppliedDateRequired: "Guyyaan Iyyannoo ni barbaachisa",
  OfficialRequestLetterRequired: "Xalayaan Gaaffii Iddoo Haalaa ni barbaachisa",
  SupportingDocumentsRequired: "Supporting Documents for Translation is required", // No Oromo translation
  PleaseFillAllRequiredFields: "Maaloo bakkeewwan barbaachisan hundi guuti",
  LegalTranslationRequestSubmittedSuccess: "Legal Translation request submitted successfully!", // No Oromo translation
  FailedToSubmitLegalTranslationRequest: "Failed to submit Legal Translation request.", // No Oromo translation
  ImportantNotes: "Yaadannoo Barbaachisaa",
  ImportantNotesText: "Sanadonni barbaachisan hundi akka fe'aman mirkaneeffadhu.",
  ImportantNotesSubtext: "Kutaan guutamuu dhabuun turara ykn kufaatii fiduu danda'a.",
  CertifiedLegalDocuments: "Sanadoota Seeraa Ragsiifaman",
  ContractsAgreementsLegalNotices: "Kontiraaktii, Walii Galtee, fi Beeksisa Seeraa",
  LegislativeDraftsPolicyDocuments: "Wixineewwan Seeraa fi Sanadoota Imileen Siyasaa",
  LegalTranslationDetails: "Ibsa Hiika Seeraa",
  RegisterLetterNumber: "Lakkoofsa Xalayaa Galmeessi",
  LegalTranslationSummaryNote: "Yaadachiisa Cuunfaa Hiika Seeraa",
  TranslationCompletionLetter: "Xalayaa Xumuramaa Hiikaa",
  LetterReferenceNumberAndCompletionLetterUploaded: "Letter Reference Number and Completion Letter uploaded successfully!", // No Oromo translation
  FailedToUploadLetterReferenceNumberAndCompletionLetter: "Failed to upload Letter Reference Number and Completion Letter.", // No Oromo translation
  SetupTeamMembersOptional: "Miseensota Garee Qopheessi (Filannoodhaan)",
  NoTeamMembersAddedYetOptional: "Hanga yoonaatti miseensi garee hin dabalame.",
  RemarkSavedSuccess: "Yaadachiisni milkaa'inaan kussameera!",
  FailedToSaveRemark: "Yaadachiisa kusuu hin danda'amne.",
  SaveOnly: "Kusuu Qofa",
  RequestForwardedSuccess: "Gaaffiin milkaa'inaan ergameera!",
  EditTeam: "Garee Gulaali",
  AddNewTeamMember: "Miseensa Garee Haaraa Dabali",
  Loading: "Fe'aa jira...",
  SearchProsecutors: "Abbootii Alangaa barbaadi...",
  NoAvailableProsecutorsFound: "Abbaan Alangaan argamu hin jiru",
  AddMember: "Miseensa Dabali",
  Adding: "Dabalaa jira...",
  NoTeamMembersFound: "Miseensi garee hin argamne",
  SetAsTeamLeader: "Dursaa Garee Taasi",
  RemoveMember: "Miseensa Haqi",
  CloseAndRefresh: "Cufi & Haaromsi",
  LegalDepartment: "Mootummaa Seeraa",
  FailedToLoadAvailableProsecutors: "Abbootii alangaa argamu fe'uun hin danda'amne.",
  TeamLeaderUpdatedSuccess: "Dursaan garee milkaa'inaan haaromfame!",
  FailedToUpdateTeamLeader: "Dursaa garee haaromsuun hin danda'amne.",
  ConfirmRemoveTeamMember: "Miseensa garee kana haquu barbaadduu mirkaneeffatteettaa?",
  TeamMemberRemovedSuccess: "Miseensi garee milkaa'inaan haqameera!",
  FailedToRemoveTeamMember: "Miseensa garee haquun hin danda'amne.",
  PleaseSelectTeamMember: "Maaloo miseensa garee fili.",
  TeamMemberAddedSuccess: "Miseensi garee milkaa'inaan dabalameera!",
  FailedToAddTeamMember: "Miseensa garee dabaluun hin danda'amne.",
  CreatedBy: "Kan Uume",
  BroadcastTranslationToPublic: "Hiika Ummataaf Tamsaasi",
  BroadcastTranslationDescription: "Hiika seeraa kee kan xumurame iftoominaa fi dhaqqabamummaa dabaluuf ummata wajjiin qooddadhu.",
  BroadcastTranslationAdditionalInfo: "Hiikanni akkuma tamsa'een ifaa fi bal'inaan dhaqqabamaa waan ta'uuf namni kamiyyuu ilaaluu danda'a.",
  ForwardToZone: "Godinaaf Dabarsi",
  Edit: "Gulaali",
  PreviousDrafts: "Wixineewwan Duraanii",
  PreviousDrafts_plural: "Wixineewwan Duraanii",
  ProsecutorAssignmentsTeam: "Abbootii Alangaa / Garee",
  NoProsecutorsAssigned: "Abbaan alangaa/garee hin ramadame.",
  DirectorOptions: "Filannoo Daayrektaraa",
  DirectorOptionsDescription: "Filannoo fili: garee qopheessi fi abbaa alangaa ergi, ykn yaadachiisa dhiyeessi fi qindeessaaf ergi.",
  LegalTranslationBroadcasted: "Legal translation broadcasted to public!", // No Oromo translation
  LegalTranslationUnpublished: "Legal translation unpublished!", // No Oromo translation
  DraftLegalTranslation: "Wixinee Hiika Seeraa",
  TranslationSummary: "Cuunfaa Hiikaa",
  LegalTrainingProvisionRequest: "Gaaffii Kenniinsa Leenjii Seeraa",
  LegalTrainingProvisionSubtitle: "Legal Training Provision Subtitle", // No Oromo translation
  RequestLetterReferenceNumberPlaceholder: "Fak. LTP/REQ/2025/014",
  LegalTrainingNeedsDescription: "Ibsa Barbaachisummaa Leenjii Seeraa *",
  LegalTrainingNeedsDescriptionPlaceholder: "Kaayyoo leenjii, qooddammoota, fi bu'aa dhaabbataa ibsi.",
  LegalTrainingNeedsDescriptionRequired: "Ibsa barbaachisummaa leenjii seeraa ni barbaachisa.",
  SupportingTrainingDocument: "Sanada Deeggarsa Leenjii *",
  SupportingTrainingDocumentRequired: "Sanadni deeggarsa leenjii ni barbaachisa.",
  SubmitTrainingRequest: "Gaaffii Leenjii Dhiyeessi",
  LegalTrainingRequestUpdatedSuccess: "Legal training request updated successfully!", // No Oromo translation
  LegalTrainingRequestSubmittedSuccess: "Legal training provision request submitted successfully!", // No Oromo translation
  FailedToSubmitLegalTrainingRequest: "Failed to submit legal training request.", // No Oromo translation
  SubmissionGuidelines: "Qajeelfama Dhiyeessaa",
  SubmissionGuidelinesText: "Sanadonni barbaachisan hundi fi sababiin ga'aan akka kennaman mirkaneeffadhu.",
  SubmissionGuidelinesSubtext: "Kutaan guutamuu dhabuun gulaalamaaf deebi'uu danda'a.",
  LegalTrainingUpdatedSuccess: "Legal Training Updated successfully!", // No Oromo translation
  Internal: "Keessaa",
  RequestForLegalTrainingProvision: "Gaaffii Kenniinsa Leenjii Seeraa",
  LegalTrainingProvisionFormSubtitle: "Legal Training Provision Form Subtitle", // No Oromo translation
  SelectStakeholder: "Qooda-Fudhattaa Fili",
  Topic: "Mata-Duree",
  TopicPlaceholder: "Fak. Mata-duree leenjii",
  TrainingSummary: "Cuunfaa Leenjii",
  TrainingSummaryPlaceholder: "Fak. Cuunfaa leenjii",
  SummaryFile: "Faayila Cuunfaa",
  LegalTrainingProvisionUpdatedSuccess: "Legal training provision updated successfully!", // No Oromo translation
  LegalTrainingProvisionSubmittedSuccess: "Legal training provision request submitted successfully!", // No Oromo translation
  FailedToSubmitLegalTrainingProvision: "Failed to submit legal training provision request.", // No Oromo translation
  LegalTrainingProvisionNoteText: "Legal Training Provision Note Text", // No Oromo translation
  LegalTrainingProvisionNoteSubtext: "Legal Training Provision Note Subtext", // No Oromo translation
  LegalTrainingProvisionDocRequirementsDesc: "Legal Training Provision Doc Requirements Desc", // No Oromo translation
  ConfirmSubmission: "Dhiyeessaa Mirkaneessi",
  ConfirmSubmissionMessage: "Gaaffii leenjii seeraa kana dhiyeessuu barbaadduu mirkaneeffatteettaa? Erga ergame booda hin gulaalamu.",
  FailedToFetchStakeholders: "Qooda-fudhattoota argachuun hin danda'amne.",
  LegalAwarenessReport: "Gabaasa Hubannoo Seeraa",
  TrainingReport: "Gabaasa Leenjii",
  LegalAwarenessReportSummary: "Cuunfaa Gabaasa Hubannoo Seeraa",
  TrainingReportSummary: "Cuunfaa Gabaasa Leenjii",
  LegalAwarenessReportDoc: "Sanada Gabaasa Hubannoo Seeraa*",
  TrainingReportDoc: "Sanada Gabaasa Leenjii*",
  TrainingReportUploaded: "Training Report Uploaded", // No Oromo translation
  FailedToUploadTrainingReport: "Failed to upload Training Report.", // No Oromo translation
  TrainingOutcome: "Bu'aa Leenjii",
  TrainingFeedback: "Duub-Deebii Leenjii",
  TrainingManual: "Maanuwaalii Leenjii",
  SummaryOfTrainingOutcome: "Cuunfaa Bu'aa Leenjii",
  SummaryOfFeedback: "Cuunfaa Duub-Deebii",
  SummaryOfTrainingManual: "Cuunfaa Maanuwaalii Leenjii",
  TrainingOutcomeDoc: "Sanada Bu'aa Leenjii*",
  FeedbackDoc: "Sanada Duub-Deebii*",
  TrainingManualDoc: "Sanada Maanuwaalii Leenjii*",
  TrainingManualUploaded: "Training Manual Uploaded", // No Oromo translation
  FailedToUploadTrainingManual: "Failed to upload Training Manual.", // No Oromo translation
  AddTrainingManual: "Maanuwaalii Leenjii Dabali",
  FailedToSubmit: "Dhiyeessuun kufeera",
  TrainingSentFrom: "Leenjiin {{adminUnit}} irraa ergame",
  RequestLetterNumber: "Lakkoofsa Xalayaa Gaaffii",
  ReUploadTrainingReport: "Gabaasa Leenjii Irra Deebi'ii Fe'i",
  UploadTrainingReport: "Gabaasa Leenjii Fe'i",
  FailedToFetchZones: "Godinoota argachuun hin danda'amne.",
  PleaseSelectAtLeastOneZone: "Maaloo yoo xiqqaate godina tokko filadhu.",
  ZoneAlreadyDistributed: "Godinni {{zoneName}} duraan raabsameera. Darbi.",
  ForwardedToZonesSuccess: "Godinoota filatamaniif milkaa'inaan ergameera!",
  DistributeToZone: "Godinaaf Raabsi",
  SelectZones: "Godinoota Fili",
  NoZonesAvailable: "Godinni hin jiru",
  SelectedZonesCount: "Godinoota Filataman ({{count}}):",
  RemoveZone: "Godina Haqi",
  ForwardToZones: "Godinootaaf Dabarsi ({{count}})",
  ConfirmDistribution: "Raabsama Mirkaneessi",
  ConfirmDistributionMessage: "Godinoota filataman {{count}} raabsuu barbaadduu mirkaneeffatteettaa? Gochi kun gaaffii waajjira godinaatti erga.",
  Distribute: "Raabsi",
  TeamAssignmentsUpdatedSuccess: "Ramaddiin garee milkaa'inaan haaromfame!",
  LegalTrainingRequestForwardedSuccess: "Legal Training Request Forwarded successfully!", // No Oromo translation
  FailedToUpdateLegalTrainingRequest: "Failed to update Legal Training request.", // No Oromo translation
  TrainingTopicSummary: "Cuunfaa Mata-Duree Leenjii",
  LatestVersion: "Gossha Haaraa",
  TrainingManualSummary: "Cuunfaa Maanuwaalii Leenjii",
  EditTrainingManual: "Maanuwaalii Leenjii Gulaali",
  TrainingOutcomeSummary: "Cuunfaa Bu'aa Leenjii",
  TrainingFeedbackDocument: "Sanada Duub-Deebii Leenjii",
  TrainingReportFor: "Gabaasa Leenjii {{zone}}",
  Submitted: "Ergameera",
  NotSubmitted: "Hin ergamne",
  ReportNotSubmittedYet: "Gabaasni Ammallee Hin Ergamne",
  TrainingReportNotUploadedMessage: "Gabaasni leenjii godina kanaaf hin fe'amne. Maaloo booda deebi'ii mirkaneessi ykn garee ilaallatu qunnami.",
  TrainingSchedule: "Sagantaa Leenjii",
  InPerson: "Fuula Duraa",
  Online: "Online",
  Hybrid: "Makuu",
  Schedule: "Sagantaa",
  ReUploadTrainingOutcome: "Bu'aa Leenjii Irra Deebi'ii Fe'i",
  UploadTrainingOutcome: "Bu'aa Leenjii Fe'i",
  ReUploadTrainingFeedback: "Duub-Deebii Leenjii Irra Deebi'ii Fe'i",
  UploadTrainingFeedback: "Duub-Deebii Leenjii Fe'i",
  Directive: "Qajeelfama",
  LegalAwareness: "Hubannoo Seeraa",
  LegalAwarenessTable: "Gabatee Hubannoo Seeraa",
  SentDate: "Guyyaa Ergame",
  ZoneProsecutor: "Abbaa Alangaa Godinaa",
  FailedToFetchLegalAwarenessRequest: "Failed to fetch legal awareness request.", // No Oromo translation
  AssignProsecutor: "Abbaa Alangaa Ramadi",
  AddToTeam: "Gareetti Dabali",
  ListOfTopic: "Tarree Mata-Duree",
  EnterTopicPlaceholder: "Mata-duree galchi",
  TargetAudience: "Dhaggeeffattoota Qophaa'e",
  EnterTargetAudiencePlaceholder: "Dhaggeeffattoota qophaa'e galchi",
  SubmittingLegalAwarenessRequest: "Gaaffii Hubannoo Seeraa Dhiyeessaa jira...",
  LegalAwarenessRequestUpdatedSuccess: "Legal Awareness Request updated successfully!", // No Oromo translation
  LegalAwarenessRequestCreatedSuccess: "Legal Awareness Request created successfully!", // No Oromo translation
  FailedToCreateLegalAwarenessRequest: "Failed to create Legal Awareness Request. Please try again.", // No Oromo translation
  PleaseEnterTopic: "Maaloo mata-duree galchi.",
  PleaseEnterTargetAudience: "Maaloo dhaggeeffattoota qophaa'e galchi.",
  PleaseAddAtLeastOneTeamMember: "Maaloo yoo xiqqaate miseensa garee tokko dabali.",
  PleaseSelectExactlyOneTeamLeader: "Maaloo dursaa garee tokko qofa fili.",
  FailedToLoadProsecutors: "Abbootii alangaa fe'uun hin danda'amne. Maaloo fuula haaromsi.",
  UploadEvidence: "Ragaa Fe'i",
  EvidenceSummary: "Cuunfaa Ragaa",
  CollectedEvidence: "Ragaan Walitti Qabame",
  EvidenceCollectors: "Walitti Qabduu Ragaa",
  CollectorNamePlaceholder: "Maqaa walitti qabduu galchi...",
  AddEvidenceCollector: "Walitti Qabduu Ragaa Dabali",
  NoCollectorsAddedYet: "Hanga yoonaatti walitti qabduun ragaa hin dabalame.",
  RemoveCollector: "Walitti qabduu haqi",
  EvidenceCollectionTeamSubmitted: "Gareen walitti qabduu ragaa ergameera!",
  EvidenceDataUploaded: "Ragaan fe'ameera",
  FailedToUploadEvidenceData: "Ragaa fe'uun kufeera.",
  LegalAwarenessOutcome: "Bu'aa Hubannoo Seeraa",
  LegalAwarenessCreationSummary: "Cuunfaa Hubannoo Seeraa Uumuu",
  OutcomeOfAwareness: "Bu'aa Hubannoo",
  LegalAwarenessSummary: "Cuunfaa Hubannoo Seeraa",
  OutcomeOfAwarenessDoc: "Sanada Bu'aa Hubannoo*",
  LegalAwarenessDoc: "Sanada Hubannoo Seeraa*",
  LegalAwarenessUploaded: "Hubannoon Seeraa Fe'ameera",
  FailedToUploadLegalAwareness: "Hubannoo seeraa fe'uun kufeera.",
  ReUploadLegalAwarenessSummary: "Cuunfaa Hubannoo Seeraa Irra Deebi'ii Fe'i",
  UploadLegalAwarenessSummary: "Cuunfaa Hubannoo Seeraa Fe'i",
  ReUploadAwarenessOutcome: "Bu'aa Hubannoo Irra Deebi'ii Fe'i",
  UploadAwarenessOutcome: "Bu'aa Hubannoo Fe'i",
  SeminarScheduleUpdatedSuccess: "Seminar Schedule updated successfully!", // No Oromo translation
  FailedToUpdateSeminarSchedule: "Failed to update Seminar Schedule.", // No Oromo translation
  LegalAwarenessSummaryUpdated: "Legal Awareness Summary updated successfully!", // No Oromo translation
  FailedToUpdateLegalAwarenessSummary: "Failed to update Legal Awareness Summary.", // No Oromo translation
  LegalAwarenessForwardedSuccess: "Legal Awareness Forwarded successfully!", // No Oromo translation
  FailedToUpdateLegalAwarenessRequest: "Failed to update Legal Awareness request.", // No Oromo translation
  SeminarSchedule: "Sagantaa Seeminaaraa",
  UpdateSchedule: "Sagantaa Haaromsi",
  RequestDetails: "Ibsa Gaaffii",
  Topics: "Mata-Dureewwan",
  AwarenessOutcome: "Bu'aa Hubannoo",
  AwarenessOutcomeSummary: "Cuunfaa Bu'aa Hubannoo",
  LegalAwarenessDocumentFile: "Faayila Sanada Hubannoo Seeraa",
  LegalAwarenessDocument: "Sanada Hubannoo Seeraa",
  LatestDocument: "Sanada Haaraa",
  PreviousDocuments: "Sanadoota Duraanii",
  UpdateSummary: "Cuunfaa Haaromsi",
  AwarenessReportFor: "Gabaasa Hubannoo {{zone}}",
  AwarenessReportSummary: "Cuunfaa Gabaasa Hubannoo",
  AwarenessReportNotUploadedMessage: "Gabaasni hubannoo godina kanaaf hin fe'amne. Maaloo booda deebi'ii mirkaneessi ykn garee ilaallatu qunnami.",
  ConfirmAction: "Gocha Mirkaneessi",
  ConfirmActionMessage: "Odeeffannoo galchafame hundaa of eeggannoon irra deebi'i. Erga mirkanaa'ee gochi kun ergamaa waan ta'uuf hin jijjiiru.",
  Confirm: "Mirkaneessi",
  IdentificationCompleted: "Addi Baafamni Xumurame",
  EnterLocation: "Iddoo galchi",
  ScheduledDateTime: "Guyyaa fi Yeroo Karoorfame",
  Location: "Iddoo",
  LegalAdviceCompletionLetter: "Xalayaa Xumuramaa Gorsa Seeraa",
  RequestForLegalAdvisory: "Gaaffii Gorsa Seeraa",
  LegalAdvisorySubtitle: "Legal Advisory Subtitle", // No Oromo translation
  LegalAdvisoryRequestRequired: "Gaaffii Gorsa Seeraa*",
  LegalAdvisoryRequestDocument: "Sanada Gaaffii Gorsa Seeraa",
  LegalAdvisorySentSuccess: "Legal Advisory request sent successfully!", // No Oromo translation
  FailedToSendLegalAdvisory: "Failed to send Legal Advisory request.", // No Oromo translation
  LegalAdvisoryNoteText: "Legal Advisory Note Text", // No Oromo translation
  LegalAdvisoryNoteSubtext: "Legal Advisory Note Subtext", // No Oromo translation
  LegalRequestSummary: "Cuunfaa Gaaffii Seeraa",
  LegalRequestSummaryRequired: "Cuunfaan Gaaffii Seeraa ni barbaachisa",
  SummaryUpdatedSuccess: "Cuunfaan milkaa'inaan haaromfame!",
  LatestAdviceFile: "Faayila Gorsaa Haaraa",
  PreviousFiles: "Faayiloota Duraanii",
  ResponseFile: "Faayila Deebisii",
  LegalAdvice: "Gorsa Seeraa",
  LegalAdvisoryForwardedSuccess: "Legal Advisory Forwarded successfully!", // No Oromo translation
  FailedToUpdateLegalAdvisoryRequest: "Failed to update Legal Advisory request.", // No Oromo translation
  SearchByReferenceNumber: "Lakkoofsa waraabbii adda baasi...",
  Searching: "Barbaadaa jira...",
  Search: "Barbaadi",
  ResultsCount: "{{count}} bu'aan \"{{term}}\" jedhameef argame",
  LoadingLawImplementationData: "Hojiirra oolmaa seeraa fe'aa jira...",
  NoResultsFound: "Bu'aan \"{{term}}\" jedhameef hin argamne",
  NoLawImplementationPapersYet: "Hanga yoonaatti waraqaan hojiirra oolmaa seeraa hin ergamne",
  SelectLawImplementationToViewDetails: "Ibsa argachuuf hojiirra oolmaa seeraa fili",
  FailedToFetchPublicLawImplementation: "Failed to fetch public law implementation data.", // No Oromo translation
  LawImplementationFollowUp: "Hojiirra Oolmaa Seeraa Keessa Deebi'uu",
  FollowupDate: "Guyyaa Keessa Deebi'ii",
  SectorRequest: "Gaaffii Damee",
  ZonalRequest: "Gaaffii Godinaa",
  CreateLawImplementationRequest: "Gaaffii Hojiirra Oolmaa Seeraa Uumi",
  CreateRequestDescription: "Ibsa asii guuti.",
  BasicInformation: "Odeeffannoo Bu'uuraa",
  AuditTarget: "Qabeena Odiitii",
  AuditTargetPlaceholder: "Seera ykn damee adda baasi",
  Description: "Ibsa",
  DescriptionPlaceholder: "Ibsa gaaffii kenni...",
  TeamSetup: "Garee Qopheessuu",
  TeamName: "Maqaa Garee",
  TeamNamePlaceholder: "Maqaa garee galchi (fak. Team Alpha)",
  CreateTeam: "Garee Uumi",
  AddTeamMembers: "Miseensota Garee Dabali",
  Add: "Dabali",
  CurrentTeamMembers: "Miseensota Garee Ammaa ({{count}})",
  CreatedTeams: "Gareewwan Uumaman ({{count}})",
  MembersCount: "{{count}} miseensa",
  PleaseEnterTeamName: "Maaloo maqaa garee galchi.",
  PleaseAddTeamMemberBeforeCreatingTeam: "Maaloo garee uumuu dura miseensa garee tokko dabali.",
  TeamNameAlreadyExists: "Maqaan garee kun duraan jira.",
  PleaseSelectProsecutorFirst: "Maaloo dura abbaa alangaa fili.",
  PleaseEnterAuditTarget: "Maaloo Qabeena Odiitii galchi.",
  PleaseEnterRemark: "Maaloo yaadachiisa galchi.",
  PleaseAddAtLeastOneTeam: "Maaloo yoo xiqqaate garee tokko dabali.",
  TeamMustHaveMembers: "Gareen \"{{teamName}}\" yoo xiqqaate miseensa tokko qabaachuu qaba.",
  TeamMustHaveLeader: "Gareen \"{{teamName}}\" dursaa garee qabaachuu qaba.",
  TaskCreatedSuccess: "Legal research Task created and prosecutors assigned!", // No Oromo translation
  FailedToSendRequest: "Gaaffii erguun kufeera.",
  UploadWoredaReport: "Gabaasa Woredaa Fe'i",
  Woreda: "Woreda",
  SummaryOfWoredaReport: "Cuunfaa Gabaasa Woredaa*",
  EnterReportSummaryPlaceholder: "Cuunfaa gabaasaa galchi...",
  ReportDocument: "Sanada Gabaasaa*",
  SubmitReport: "Gabaasa Dhiyeessi",
  PleaseProvideReportSummary: "Maaloo cuunfaa gabaasaa kenni.",
  PleaseSelectReportFile: "Maaloo faayila gabaasaa fili.",
  WoredaReportUploadedSuccess: "Gabaasni Woredaa milkaa'inaan fe'ameera!",
  FailedToUploadWoredaReport: "Gabaasa woredaa fe'uun kufeera.",
  UploadEnforcementAnalysis: "Xiinxala Raawwiinsa Fe'i",
  EnforcementAnalysisFile: "Faayila Xiinxala Raawwiinsa",
  CurrentFile: "(faayila ammaa)",
  EnforcementAnalysisSummary: "Cuunfaa Xiinxala Raawwiinsa",
  EnterEnforcementAnalysisSummaryPlaceholder: "Cuunfaa xiinxala raawwiinsa galchi...",
  Upload: "Fe'i",
  EnforcementAnalysisUploadedSuccess: "Xiinxalli Raawwiinsa milkaa'inaan fe'ameera!",
  FailedToUploadEnforcementAnalysis: "Xiinxala raawwiinsa fe'uun kufeera.",
  Audit: "Odiitii",
  UploadIdentifiedLawOrSector: "Seera ykn Damee Addi Baafame Fe'i",
  EnforcementAnalysisDocument: "Sanada Xiinxala Raawwiinsa*",
  TargetName: "Maqaa Qabeenaa",
  EnterTargetNamePlaceholder: "Maqaa qabeenaa galchi",
  AddTarget: "Qabeena Dabali",
  AddedTargets: "Qabeenwonni Dabalaman",
  NoTargetsAddedYet: "Hanga yoonaatti qabeensi hin dabalame",
  AddAtLeastOneTargetToContinue: "Itti fufuuf yoo xiqqaate qabeena tokko dabali",
  RemoveTarget: "Qabeena Haqi",
  PleaseAddAtLeastOneTarget: "Maaloo yoo xiqqaate Qabeena tokko dabali.",
  OnlyTeamLeadersCanAddTargets: "Dursaan garee qofatu qabeenya dabaluu danda'a.",
  EnterDetailedSummaryPlaceholder: "Cuunfaa bal'aa asitti galchi...",
  LawImplementationUploaded: "Hojiirri Oolmaa Seeraa Fe'ameera",
  FailedToUploadLawImplementation: "Hojiirra oolmaa seeraa fe'uun kufeera.",
  TeamUpdatedSuccess: "Gareen milkaa'inaan haaromfame!",
  FailedToUpdateTeam: "Garee haaromsuun hin danda'amne. Maaloo irra deebi'i.",
  EditTeamDetails: "Ibsa Garee Gulaali",
  EnterTeamNamePlaceholder: "Maqaa garee galchi",
  TeamNameWillBeUpdated: "Maqaan garee ni haaromfama",
  TeamLeaderWillBeChanged: "Dursaan garee ni jijjiirrama",
  SelectTeamLeader: "Dursaa garee fili",
  SelectedLeader: "Dursaa Filatame",
  PendingChanges: "Jijjiirramni Eegamaa jira",
  UpdateTeamNameTo: "Maqaa garee gara {{teamName}} jijjiiri",
  ChangeTeamLeaderTo: "Dursaa garee gara {{leaderName}} jijjiiri",
  Updating: "Haaromfamaa jira...",
  UpdateTeam: "Garee Haaromsi",
  IdentifiedLawSectors: "Seerotaa fi Dameewwan Addi Baafaman ({{count}})",
  AcceptedTargets: "Qabeenwonni Fudhataman ({{count}}):",
  SubmitAcceptedTargets: "Qabeenwonnii Fudhataman Dhiyeessi",
  UnknownTeam: "Garee Hin beekamne",
  SubmittedBy: "Kan Dhiyeesse",
  Accept: "Fudhadhu",
  NotAccepted: "Hin Fudhatamne",
  ViewAudit: "Odiitii Ilaali",
  LawImplementationPublished: "Hojiirri Oolmaa Seeraa Maxxanfame",
  NoDescriptionAvailable: "Ibsi hin jiru",
  AuditFindings: "Bu'aa Odiitii",
  ImplementationTeam: "Garee Hojiirra Oolmaa",
  ViewTeamMembers: "Miseensota Garee Ilaali",
  AttachedDocuments: "Sanadoota Itti Qabsiifaman",
  UploadAuditTarget: "Qabeena Odiitii Fe'i",
  InsertEvidence: "Ragaa Galchi",
  InsertEnforcementAnalysis: "Xiinxala Raawwiinsa Galchi",
  RegistrarArchiveSection: "Kutaa Kuusaa Galmeessaa",
  AuditFindingsFiles: "Faayiloota Bu'aa Odiitii",
  SaveAndArchive: "Kusii Kuusaa Keessa Galchi",
  ArchiveDetailsSubmittedSuccess: "Archive details submitted successfully!", // No Oromo translation
  FailedToArchiveRequest: "Gaaffii kuusaa keessa galchuun kufeera.",
  LegalAwarenessForZoneImplementation: "Hubannoo Seeraa Hojiirra Oolma Godinaaf",
  LegalAwarenessSentFrom: "Hubannoon Seeraa {{adminUnit}} irraa ergame",
  DistributedWoredas: "Woredaawwan Raabsaman",
  Sent: "Ergameera",
  UploadReport: "Gabaasa Fe'i",
  DistributeToWoreda: "Woredaaf Raabsi",
  ReUploadLegalAwarenessReport: "Gabaasa Hubannoo Seeraa Irra Deebi'ii Fe'i",
  UploadLegalAwarenessReport: "Gabaasa Hubannoo Seeraa Fe'i",
  RequestForLawImplementation: "Gaaffii Hojiirra Oolmaa Seeraa",
  AuditTargetOverview: "Ibsa Qabeena Odiitii",
  TeamSubmissionStatus: "Haala Dhiyeessaa Garee",
  NotAssigned: "Hin Ramadamne",
  Pending: "Deemsa Irra Jira",
  EnforcementAnalysis: "Xiinxala Raawwiinsa",
  OfficialDocument: "Sanada Iddoo Haalaa",
  AttachedFile: "Faayila Itti Qabsiifame",
  UpdateFile: "Faayila Haaromsi",
  NoEnforcementAnalysisFile: "Faayiliin xiinxala raawwiinsa hin fe'amne.",
  AuditExecutionDetail: "Ibsa Hojiirra Oolma Odiitii",
  AuditFinding: "Bu'aa Odiitii",
  SectorFeedback: "Duub-Deebii Damee",
  SectorFeedbackSummary: "Cuunfaa Duub-Deebii Damee",
  NoSectorFeedbackFile: "Faayiliin duub-deebii damee hin jiru.",
  CollectorsList: "Tarree Walitti Qabduu",
  CollectorsTeam: "Garee Walitti Qabduu",
  Evidence: "Ragaa",
  History: "Seenaa",
  DistributeToWoredaDescription: "Hubannoo seeraa godina keessatti waajjirootatti raabsi.",
  SelectWoredas: "Woredaawwan Fili",
  NoWoredasAvailable: "Woredaan hin jiru",
  SelectedWoredasCount: "Woredaawwan Filataman ({{count}}):",
  RemoveWoreda: "Woreda Haqi",
  Processing: "Adeemsaa jira...",
  DistributeToWoredasButton: "Woredaaf Raabsi ({{count}})",
  PleaseSelectAtLeastOneWoreda: "Maaloo yoo xiqqaate woreda tokko filadhu.",
  DistributedToWoredasSuccess: "Woredaawwan filatamaniif milkaa'inaan raabsame!",
  FailedToDistributeToWoredas: "Woredaaf raabsuun kufeera.",
  ConfirmDistributionToWoredas: "Raabsama Mirkaneessi",
  ConfirmDistributionToWoredasMessage: "Woredaawwan filataman {{count}} raabsuu barbaadduu mirkaneeffatteettaa? Gochi kun gaaffii waajjirootatti erga.",
  LawImplementationUnpublished: "Law implementation unpublished!", // No Oromo translation
  BroadcastLawImplementationDescription: "Broadcast Law Implementation Description", // No Oromo translation
  BroadcastLawImplementationAdditionalInfo: "Broadcast Law Implementation Additional Info", // No Oromo translation
  Law: "Seera",
  ShowEvidences: "Ragaa Agarsiisi",
  AllEvidence: "Ragaan Hundi:",
  EvidenceNumber: "Ragaa #{{number}}",
  FileCount: "{{count}} faayila",
  FileCount_plural: "{{count}} faayiloota",
  CollectorCount: "{{count}} walitti qabduu",
  CollectorCount_plural: "{{count}} walitti qabduu",
  NoAuditFindingsFile: "Faayiliin bu'aa odiitii hin jiru.",
  AuditDocuments: "Sanadoota Odiitii",
  Dashboard: "Dashboard", // No Oromo translation
  DashboardSubtitle: "Dashboard Subtitle", // No Oromo translation
  TotalRequests: "Total Requests", // No Oromo translation
  ActiveTasks: "Active Tasks", // No Oromo translation
  Completed: "Completed", // No Oromo translation
  PendingReview: "Pending Review", // No Oromo translation
  ChangeFromLastMonth: "Change from last month", // No Oromo translation
  ServiceOverview: "Service Overview", // No Oromo translation
  ServiceOverviewSubtitle: "Service Overview Subtitle", // No Oromo translation
  LegalResearchRequestTypes: "Legal Research Request • Committee Request", // No Oromo translation
  DraftLegislationRequests: "Draft legislation requests", // No Oromo translation
  LegalAdviceRequests: "Legal advice requests", // No Oromo translation
  SectorDirectiveReviews: "Sector directive reviews", // No Oromo translation
  DirectiveRegistrationRequests: "Directive registration requests", // No Oromo translation
  ExternalInternal: "External • Internal", // No Oromo translation
  External: "Ext", // No Oromo translation
  ImplementationMonitoring: "Implementation monitoring", // No Oromo translation
  PublicAwarenessCampaigns: "Public awareness campaigns", // No Oromo translation
  TrainingPrograms: "Training programs", // No Oromo translation
  QuickActions: "Quick Actions", // No Oromo translation
  NavigateToServices: "Navigate to services", // No Oromo translation
  requests: "requests", // No Oromo translation
  ErrorLoadingDashboardData: "Error loading dashboard data", // No Oromo translation,
  // Dashboard
  rd_dashboard: "Daashboordii",
  rd_welcome_back: "Baga nagaan dhuftan",
  rd_overview: "Waliigala gaaffilee tarree hojii keessan keessa jiranii.",
  rd_view_all: "Hunda ilaali",
  rd_load_failed: "Tarree kana fe'uun hin danda'amne",
  rd_recent: "Dhiyoo",
  rd_no_data: "Ammaaf wanti agarsiifamu hin jiru",
  rd_loading: "Fe'aa jira...",
  rd_no_modules: "Gahee keessaniif tarreen hojii hin jiru.",
  rd_in_your_list: "Tarree keessan keessa",
  rd_workload_by_module: "Ba'aa hojii tajaajilaan",
  rd_items: "Waliigala",
  rd_by_status: "haalaan",
  rd_waiting_for_you: "Tarkaanfii keessan kan eegan",
  rd_nothing_waiting: "Wanti tarkaanfii keessan eegu hin jiru.",
  CheckingAccuracyOfSectors: "Sirrummaa Qajeelfamoota Damee Mirkaneessuu",
  RegisteringDirectives: "Qajeelfamoota Galmeessuu",
};

export default or;